module.exports = __webpack_public_path__ + "Blue_Advantage_Gold_Certified.4d1baffcb6e8fd3e6aea.png";